import React from "react";
import ComponentForgotPassword from "./components/ComponentForgotPassword";
import ComponentInvoice from "./components/ComponentInvoice";
import ComponentMutation from "./components/ComponentMutation";
import ComponentTopup from "./components/ComponentTopup";
import CreatePassword from "./components/createPasswordComponent";
import Home from "./components/homeComponent";
import Info from "./components/infoComponent";
import InfoDetailMobile from "./components/infoComponent/infoDetailMobile";
import Login from "./components/loginComponent";
import Profile from "./components/profileComponent";

import Inbox from "./components/inboxComponent";
import AccountComponent from "./components/accountComponent";
import CardComponent from "./components/cardComponent";
import CardHelpMobile from "./components/cardComponent/cardHelpMobile";
import ScheduleComponent from "./components/scheduleComponent";
import CalendarComponent from "./components/calendarComponent";
import ComponentTopupHistory from "./components/ComponentTopupHistory";
import ComponentTransactionHistory from "./components/ComponentTransactionHistory";
import ComponentTransactionDetailHistory from "./components/ComponentTransactionDetailHistory";
import ComponentAttendance from "./components/ComponentAttendance";
import ComponentAttendanceDetail from "./components/ComponentAttendanceDetail";
import ComponentDonation from "./components/ComponentDonation";
import ComponentDonationDetail from "./components/ComponentDonationDetail";
import ComponentEditProfile from "./components/ComponentEditProfile";
import ComponentAutoLogin from "./components/ComponentAutoLogin";
import ComponentChangePassword from "./components/ComponentChangePassword";
import ComponentFAQ from "./components/ComponentFAQ";
import ComponentChangeLanguage from "./components/ComponentChangeLanguage";
import ComponentTopupTutorial from "./components/ComponentTopupTutorial";
import ComponentForgotPasswordConfirmation from "./components/ComponentForgotPasswordConfirmation";
import ComponentForgotPasswordOTP from "./components/ComponentForgotPasswordOTP";
import ComponentForgotPasswordCreate from "./components/ComponentForgotPasswordCreate";
import ConfirmationData from "./components/confirmationDataComponent";
import ConfirmationDataIntro from "./components/confirmationDataIntroComponent";
import BurekolComponent from "./components/burekolComponent";
import SyncHistoryMobile from "./components/cardComponent/syncHistoryMobile";
import SyncHistoryComponent from "./components/cardComponent/syncHistory";
import ComponentInactiveError from "./components/ComponentInactiveError";
import PickupStudent from "./components/pickupStudentComponent";
import ScanPickupStudent from "./components/pickupStudentScanComponent";
import CreateQRPickupStudent from "./components/pickupStudentCreateQRComponent";
import BookingPickupStudent from "./components/pickupStudentBookingComponent";
import StatusBookingPickupStudent from "./components/pickupStudentStatusComponent";
import StatusBookingDetailPickupStudent from "./components/pickupStudentStatusDetailComponent";
import ComponentAttendancePro from "./components/ComponentAttendancePro";
import ComponentSupport from "./components/ComponentSupport";
import ComponentInvoiceDetail from "./components/ComponentInvoiceDetail";
import ComponentInvoiceCreditPayment from "./components/ComponentInvoiceCreditPayment";
import RecitationSubmission from "./components/recitationSubmissionComponent";
import { RecitationSubmissionReport } from "./components/recitationSubmissionReportComponent";
import RecitationDetail from "./components/recitationDetail";
import { MedicalRecordRoute } from "./routes/medicalRecordRoute";

import Saving from "./components/savingComponent";
import SavingCreate from "./components/savingCreateComponent";
import ReceiptMobile from "./components/savingComponent/receiptMobile";
import ViolationPoint from "./components/violationPointComponent";
import ViolationPointReward from "./components/violationPointRewardComponent";
import ViolationPointViolation from "./components/violationPointViolationComponent";
import ViolationPointForm from "./components/violationPointFormComponent";
import ViolationPointRewardDetailComponent from "./components/violationPointRewardDetailComponent";
import ViolationPointViolationDetailComponent from "./components/violationPointViolationDetailComponent";
import PerizinanMobile from "./components/perizinanComponent/perizinanMobile";
import FormMobile from "./components/perizinanComponent/formMobile";
import DetailPerizinanMobile from "./components/perizinanComponent/detailPerizinanMobile";
import ComponentInvoiceHistoryDetail from "./components/ComponentInvoice/historyDetailComponent";

const Routes: any = [
  {
    path: "",
    redirect: "Home",
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "login",
    component: Login,
  },
  {
    path: "confirmation-data",
    component: ConfirmationData,
  },
  {
    path: "confirmation-data/intro",
    component: ConfirmationDataIntro,
  },
  {
    path: "create-password",
    component: CreatePassword,
  },
  {
    path: "forgot-password",
    component: ComponentForgotPassword,
  },
  {
    path: "forgot-password-confirmation",
    component: ComponentForgotPasswordConfirmation,
  },
  {
    path: "forgot-password-otp",
    component: ComponentForgotPasswordOTP,
  },
  {
    path: "forgot-password-create",
    component: ComponentForgotPasswordCreate,
  },
  {
    path: "profile",
    component: Profile,
  },
  {
    path: "edit-profile",
    component: ComponentEditProfile,
  },
  {
    path: "topup",
    component: ComponentTopup,
  },
  {
    path: "topup-history",
    component: ComponentTopupHistory,
  },
  {
    path: "/info",
    component: Info,
  },
  {
    path: "/info-detail/:id",
    component: InfoDetailMobile,
  },
  {
    path: "/message",
    component: Inbox,
  },
  {
    path: "account",
    component: AccountComponent,
  },
  {
    path: "digital-card",
    component: CardComponent,
  },
  {
    path: "digital-card/:id/",
    component: SyncHistoryComponent,
  },
  {
    path: "schedule",
    component: ScheduleComponent,
  },
  {
    path: "calendar",
    component: CalendarComponent,
  },
  {
    path: "invoice",
    component: ComponentInvoice,
  },

  {
    path: "invoicedetail/:id",
    component: ComponentInvoiceDetail,
  },
  {
    path: "invoice/history/detail",
    component: ComponentInvoiceHistoryDetail,
  },
  {
    path: "invoice-credit-payment",
    component: ComponentInvoiceCreditPayment,
  },
  {
    path: "mutation",
    component: ComponentMutation,
  },
  {
    path: "transaction-history",
    component: ComponentTransactionHistory,
  },
  {
    path: "transaction-detail",
    component: ComponentTransactionDetailHistory,
  },
  {
    path: "attendance",
    component: ComponentAttendance,
  },
  {
    path: "attendance-detail",
    component: ComponentAttendanceDetail,
  },
  {
    path: "donation",
    component: ComponentDonation,
  },
  {
    path: "donation-detail",
    component: ComponentDonationDetail,
  },
  {
    path: "auto-login",
    component: ComponentAutoLogin,
  },
  {
    path: "change-password",
    component: ComponentChangePassword,
  },
  {
    path: "faq",
    component: ComponentFAQ,
  },
  {
    path: "burekol",
    component: BurekolComponent,
  },
  {
    path: "burekol/:bankName",
    component: BurekolComponent,
  },
  {
    path: "change-language",
    component: ComponentChangeLanguage,
  },
  {
    path: "topup-tutorial",
    component: ComponentTopupTutorial,
  },
  {
    path: "inactive/:name/:error",
    component: ComponentInactiveError,
  },
  {
    path: "pickup-student",
    component: PickupStudent,
  },
  {
    path: "pickup-student/scan/:studentId/:grade",
    component: ScanPickupStudent,
  },
  {
    path: "pickup-student/create-qr/:studentId/:grade/:studentName",
    component: CreateQRPickupStudent,
  },
  {
    path: "pickup-student/booking",
    component: BookingPickupStudent,
  },
  {
    path: "pickup-student/status",
    component: StatusBookingPickupStudent,
  },
  {
    path: "pickup-student/status/:id",
    component: StatusBookingDetailPickupStudent,
  },
  { path: "/attendance-pro", component: ComponentAttendancePro },
  {
    path: "/point-guard",
    component: ViolationPoint,
  },
  {
    path: "/point-guard/reward",
    component: ViolationPointReward,
  },
  {
    path: "/point-guard/violation",
    component: ViolationPointViolation,
  },
  {
    path: "/point-guard/reward/create",
    component: ViolationPointForm,
  },
  {
    path: "/point-guard/reward/:id",
    component: ViolationPointRewardDetailComponent,
  },
  {
    path: "/point-guard/violation/:id",
    component: ViolationPointViolationDetailComponent,
  },
  { path: "etc", component: ComponentSupport },
  {
    path: "setoran-hafalan",
    component: RecitationSubmission,
  },
  {
    path: "setoran-hafalan/report",
    component: RecitationSubmissionReport,
  },
  {
    path: "setoran-hafalan/detail",
    component: RecitationDetail,
  },
  {
    path: "saving",
    component: Saving,
  },
  {
    path: "saving/mutation/:id",
    component: ReceiptMobile,
  },
  {
    path: "saving/mutation",
    component: ReceiptMobile,
  },
  {
    path: "saving/create",
    component: SavingCreate,
  },
  {
    path: "perizinan",
    component: PerizinanMobile,
  },
  {
    path: "perizinan/form",
    component: FormMobile,
  },
  {
    path: "perizinan/:id/detail",
    component: DetailPerizinanMobile,
  },
  ...MedicalRecordRoute,
];
export default Routes;
